export default __webpack_public_path__ + "static/media/hero-ellipse.7aa0de0a.svg";